import GenDuo from '../public/genduo'
import H2Title from '../public/h2Title'
import { BASE_URL } from '../../api/api'
import NavLink from '../navLink'

const Zjzk = ({ expertList = [] }) => {
  // console.log(expertList?.[0]?.id)

  return (
    <div className="w-full bg-homeZjzk bg-cover lg:pb-10 mt-[60px] px-5 lg:px-0">
      <div className="max-w-1200 mx-auto pt-[41px] pb-[40px] lg:pb-0">
        <div className="flex justify-center lg:justify-between items-center">
          <p></p>
          <H2Title className="mb-9" title="专家智库" />
          <GenDuo
            href={`/zjzk/channel_id/${expertList?.[0]?.channel_id}`}
            className="hidden lg:block"
          />
        </div>
        <div className="flex justify-between flex-wrap">
          {expertList.map(({ title, image = '', id, outlink }, key) => (
            <NavLink
              key={key}
              className="mt-0"
              isOutLink={!!outlink}
              to={outlink || `/wzxq/id/${id}`}
            >
              <div key={key} className="w-[100px] lg:w-[190px] mt-2">
                <img src={`${BASE_URL}${image}`} height={154} alt="" />
                <p className="mt-2 text-[#666666] text-center">{title}</p>
              </div>
            </NavLink>
          ))}
          <div className="lg:w-[190px]" />
          <div className="lg:w-[190px]" />
          <div className="lg:w-[190px]" />
          <div className="lg:w-[190px]" />
          <div className="lg:w-[190px]" />
        </div>
        <div className="flex lg:hidden justify-center mt-8">
          <GenDuo
            href={`/zjzk/channel_id/${expertList?.[0]?.channel_id}`}
            className="mx-auto bg-[#0189D5] px-6 py-2 rounded-xl text-white"
          />
        </div>
      </div>
    </div>
  )
}

export default Zjzk
